import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { FormControlLabel, Radio } from '@material-ui/core';
import { InputGroup, Panel, Typography } from '@icecreamsocial/components';

import { ClientSelector } from '../../../../../containers';
import { RequiredAsterisk } from '../../../..';
import { useUserSettingsForm } from '../../..';
/**
 * @module ClientSelectorToggle
 * @category Components
 * @subcategory Presentational
 * @requires module:UserSettingsForm
 * @requires module:UserRole
 */

/**
 * @name ClientSelectorToggle
 * @description
 * A radio that shows or hides the client.  If selected, this will set the `role` to `'client'` and the selector will be required
 * If readonly, the radio will not be shown but the selector will in a readonly state.
 */

const ClientSelectorToggle = ({ affiliateId }) => {
	const { form, userClientId, isEditing: isReadonly } = useUserSettingsForm();
	return (
		<Panel
			border={form.values.role === 'client' ? 'default' : 'none'}
			backgroundColor={
				form.values.role === 'client' ? 'bodyInverse' : 'ambientLight'
			}
		>
			<Panel.Body>
				{isReadonly ? (
					<Typography.Span typoWeight='bold'>Client User</Typography.Span>
				) : (
					<FormControlLabel
						control={
							<Radio
								checked={form.values.role === 'client'}
								name='role'
								value='client'
								onChange={form.handleChange}
								color='primary'
								required
							/>
						}
						label={
							<Typography.Span typoWeight='bold'>Client User</Typography.Span>
						}
					/>
				)}
				<Typography.P>
					Client Users have the ability to create and edit clients and
					sub-clients. They can view data related to their clients' campaigns
					but cannot modify them or issue rewards.
				</Typography.P>
				{form.values.role === 'client' && (
					<InputGroup elWidth='100%' marginBottom='sm'>
						<InputGroup.Label>
							Client <RequiredAsterisk />
						</InputGroup.Label>
						<ClientSelector
							name='clientId'
							placeholder='Choose a client'
							affiliateId={affiliateId}
							clientId={userClientId}
							paddingLeft='md'
							isSearchable={!isReadonly}
							isClearable={isReadonly}
							isDisabled={isReadonly}
						/>
					</InputGroup>
				)}
			</Panel.Body>
		</Panel>
	);
};
ClientSelectorToggle.displayName =
	'UserSettingsForm.UserRole.ClientSelectorToggle';

export default observer(ClientSelectorToggle);
